import React, { useEffect, useState } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import LoopIcon from "@material-ui/icons/Loop";
import { useGrammar } from "context/grammarContext";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";

import Paper from "@material-ui/core/Paper";
// import GetAppIcon from "@material-ui/icons/GetApp";

import "./AccordionResponse.css";
import { Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
// import Loading from "components/Loading/loading";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 160,
    width: 120,
  },
  control: {
    padding: theme.spacing(2),
  },
  heading: {
    color: "black",
  },
  resizable: {
    position: "relative",
    "& .react-resizable-handle": {
      position: "absolute",
      width: 20,
      height: 20,
      bottom: 0,
      right: 0,
      background:
        "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
      "background-position": "bottom right",
      padding: "0 3px 3px 0",
      "background-repeat": "no-repeat",
      "background-origin": "content-box",
      "box-sizing": "border-box",
      cursor: "se-resize",
    },
  },
}));

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function AccordionResponse(props) {
  const classes = useStyles();
  const {
    openByClickCYK,
    setOpenByClickCYK,
    openByClickLeftMost,
    setOpenByClickLeftMost,
    openByClickAmbiguity,
    setOpenByClickAmbiguity,
  } = useGrammar();
  const [expanded, setExpanded] = React.useState(false);
  const [response, setResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const [teste] = useState(props.open);
  // const [panel, setPanel] = useState("");
  const [expandAlgorithm, setExpandAlgorithm] = useState(false);

  const handleChange = (panel) => async (event, isExpanded) => {
    if (isExpanded) {
      setIsLoading(true);
      const responseFunction = await props.function();
      setResponse(responseFunction);
      setIsLoading(false);
    } else {
      if (props.panel === "CYK") {
        setOpenByClickCYK(false);
      } else if (props.panel === "LeftMost") {
        setOpenByClickLeftMost(false);
      } else if (props.panel === "Ambiguity") {
        setOpenByClickAmbiguity(false);
      }
    }
    setExpanded(isExpanded ? panel : false);
  };

  // function handleAccodClick(day) {
  //   if (panel !== day) setPanel("");
  //   if (panel === day) setPanel(day);
  // }

  const runFunction = async () => {
    try {
      setIsLoading(true);
      const responseFunction = await props.function();
      setResponse(responseFunction);
      setIsLoading(false);
    } catch (e) {
      alert(e);
    }
  };

  useEffect(() => {
    if (openByClickCYK === true && props.panel === "CYK") {
      runFunction();
      setExpanded("CYK");
      setOpenByClickCYK(false);
    }
  }, [openByClickCYK]);

  useEffect(() => {
    if (openByClickLeftMost === true && props.panel === "LeftMost") {
      runFunction();
      setExpanded("LeftMost");
      setOpenByClickLeftMost(false);
    }
  }, [openByClickLeftMost]);

  useEffect(() => {
    if (openByClickAmbiguity === true && props.panel === "Ambiguity") {
      runFunction();
      setExpanded("Ambiguity");
      setOpenByClickAmbiguity(false);
    }
  }, [openByClickAmbiguity]);

  const expandDialog = () => {
    setExpandAlgorithm(true);
  };

  const handleClose = () => {
    setExpandAlgorithm(false);
  };
  return (
    <div>
      <Dialog
        open={expandAlgorithm}
        keepMounted
        onClose={handleClose}
        className="dialog"
        scroll="body"
        maxWidth="xl"
        PaperComponent={PaperComponent}
      >
        <ResizableBox
          height={window.innerHeight * 0.75}
          width={window.innerWidth * 0.75}
          className={classes.resizable}
        >
          <div>
            <DialogTitle className={classes.dialog} id="draggable-dialog-title">
              <div className="wrapper-title">
                {props.title}
                <div className="wrapper-button-close button-margin">
                  <Button
                    style={{ backgroundColor: "#999", color: "#FFF" }}
                    onClick={handleClose}
                  >
                    X
                  </Button>
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="wrapper-response">
                <div className="">{response}</div>
              </div>
            </DialogContent>
          </div>
        </ResizableBox>
      </Dialog>
      <Accordion
        expanded={expanded === props.panel}
        onChange={handleChange(props.panel)}
        defaultExpanded={false}
        style={{
          backgroundColor: props.color,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          // height: "2em",
          // display: "flex",
          // alignItems: "center",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon htmlColor="black" />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          {isLoading && <LoopIcon className="rotate " />}

          <div>
            <Typography className={classes.heading}>{props.title}</Typography>
          </div>
          {expanded && (
            <div className="wrapper-expand-icon">
              <AspectRatioIcon
                className="expand-icon"
                onClick={() => {
                  expandDialog();
                }}
              />
            </div>
          )}
        </AccordionSummary>
        <AccordionDetails className="content-response">
          {response && <div className="internal-gram">{response}</div>}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
